import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import RightArrow from "../../components/SVG";

import videoBG from "../../assets/img/sap/videosection.jpg";
import shapeImg1 from "../../assets/img/video/shape-1-2.png";
import shapeImg2 from "../../assets/img/video/shape-1-3.png";
import shapeImg3 from "../../assets/img/video/shape-1-4.png";
import shapeImg4 from "../../assets/img/video/shape-1-5.png";
import fishvideo from "../../assets/img/sap/fishvideo.mp4";

const Video = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  const style = {
    color: "#ffd15c",
  };

  return (
    <div
      className="it-video-area it-video-bg p-relative fix pt-50 pb-50 pb-0 pb-md-5"
      style={{ backgroundImage: `url(${videoBG})` }}
    >
      {/* Local Video Modal */}
      <Modal show={isOpen} onHide={openModal} centered size="lg">
        <Modal.Body className="p-0">
          <video autoPlay loop style={{ width: "100%" }}>
            <source src={fishvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Modal.Body>
      </Modal>

      {/* Shapes */}
      <div className="it-video-shape-2 d-none d-lg-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-video-shape-3 d-none d-lg-block">
        <img src={shapeImg2} alt="" />
      </div>
      {/* <div className="it-video-shape-4 d-none d-lg-block">
        <img src={shapeImg3} alt="" />
      </div> */}
      <div className="it-video-shape-5 d-none d-lg-block">
        <img src={shapeImg4} alt="" />
      </div>

      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-8 col-lg-8 col-md-9 col-sm-9">
            <div className="it-video-content yellow">
              <h3 className="it-video-title" style={style}>
                Benefits of Membership in SAP
              </h3>
              <div class="it-about-5-list mb-40">
                <ul style={{ backgroundColor: "transparent" }}>
                  <li style={{ color: "white" }}>
                    <i class="fa-regular fa-check"></i>Networking with top and
                    emerging leaders in the aquaculture industry, academia and
                    research world
                  </li>
                  <li style={{ color: "white" }}>
                    <i class="fa-regular fa-check"></i>Reach the strategic
                    partners of SAP such as the Global Aquaculture Alliance,
                    World Aquaculture Society and the Institution of Aquaculture
                    and gain from their exclusive offers for SAP members
                  </li>
                </ul>
              </div>
              <div className="it-video-button ">
                <Link className="ed-btn-yellow" to="/signup">
                  <span>
                    Become a SAP member now
                    <i>
                      <RightArrow />
                    </i>
                  </span>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-3 col-sm-3 d-none d-md-block">
            <div className="it-video-play-wrap d-flex justify-content-start justify-content-md-end align-items-center">
              <div className="it-video-play text-center">
                <Link className="popup-video play" to="#" onClick={openModal}>
                  <i className="fas fa-play"></i>
                </Link>
                {/* <Link className="text" to="#" onClick={openModal}>
                  watch now
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
